import { buildMode, BuildMode } from "@/services/buildMode";
import type { OrderId } from "@/services/marketplace/order/orderTypes";

const ZBOZI_ID = 289524;

enum Event {
  Conversion = "zbozi_conversion",
}

enum ZboziType {
  Standard = "standard",
  Sandbox = "sandbox",
}

const trackConversion = (orderId: OrderId): void => {
  if (buildMode === BuildMode.Development) {
    return;
  }
  if (!Array.isArray(window.dataLayer)) {
    console.warn("GTM dataLayer not found — Zbozi conversion not sent.");
    return;
  }

  const zboziType = buildMode === BuildMode.Production ? ZboziType.Standard : ZboziType.Sandbox;

  window.dataLayer.push({
    event: Event.Conversion,
    zboziId: ZBOZI_ID,
    zboziOrderId: String(orderId),
    zboziConsent: 1,
    zboziType,
  });
};

export default { trackConversion };
